// extracted by mini-css-extract-plugin
export default {"imageTitle":"imageTitle-sKj7NUm3","compact":"compact-dsyvuwgE","image":"image-AizXLe48","sm":"sm-nbKvX7uf","md":"md-Ns90uo2s","lg":"lg-dyCYQz4o"};